///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component } from '@angular/core';
import { AbstractDialogManager } from '../../../dialog-manager/abstract-dialog-manager';
import { CustomerLocationDialogComponent } from './customer-location-dialog.component';

@Component({
    selector: 'winde-customer-location-dialog-wrapper-component',
    template: ''
})
export class CustomerLocationDialogWrapperComponent extends AbstractDialogManager<unknown, CustomerLocationDialogComponent> {
    constructor() {
        super(CustomerLocationDialogComponent);
        this.openDialog();
    }

    preparingBaseConfig(): void {
        this.baseConfig.width = '800px';
        this.baseConfig.position = { top: '30px' };
    }
}
